





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AccountData } from '../classes/accountData';
import PhoneInput from 'modules/core/components/forms/PhoneInput.vue';
import { Languages } from 'modules/core/enums/languages';
import { ElForm } from 'element-ui/types/form';
import { Integrations } from '../enums/integrations';

@Component({
  components: {
    PhoneInput,
  },
})
export default class Login extends Vue {
  @Prop() public data!: AccountData;
  @Prop() public integration!: Integrations;
  public form: AccountData = new AccountData();
  @Prop() public accountExist!: boolean;
  public termsAccepted: boolean = false;
  public formRules!: any;
  @Prop() public loading!: boolean;

  public created() {
    this.form = this.data;

    this.formRules = this.createValidationRules();
  }

  public createValidationRules() {
    return {
      password: [
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (this.accountExist) {
              if (this.form.password) {
                callback();
              } else {
                callback(new Error(this.$t('forms.required') as string));
              }
            } else {
              callback();
            }
          },
        },
      ],
      email: [
        { required: true, message: this.$t('forms.missingField', { field: this.$t('wizard.account.email') }), trigger: 'blur' },
        { type: 'email', required: true, message: this.$t('forms.invalidEmail'), trigger: 'blur' },
      ],
    };
  }

  public updateEmail(val: any) {
    this.$emit('checkEmail', this.form.email);
    this.updateAccountData();
  }

  public updateAccountData() {
    this.$emit('update', this.form);
  }

  public refershLanguage() {
    this.formRules = this.createValidationRules();
  }

  public async validateForm() {
    return new Promise((resolve, reject) => {
      (this.$refs.form as ElForm).validate((isValid: boolean, invalidFields: object) => {
        if (!isValid) {
          let errors = '';
          for (const field in invalidFields) {
            if (field) {
              // @ts-ignore
              const settings: any = invalidFields[field];
              for (const sett of settings) {
                errors += `<p>${sett.message}</p>`;
              }
            }
          }

          this.$message({
            message: errors,
            type: 'error',
            dangerouslyUseHTMLString: true,
          });
        }

        resolve(isValid);
      });
    });
  }

  public goToRegister() {
    this.$emit('goToRegister', true);
  }

  public login() {
    this.$emit('login', true);
  }
}
